import { Link } from 'react-router-dom';
import { PortalPageHead } from '@/components/portal/PortalChrome';
import { PortalIcon } from '@/components/portal/PortalIcon';
import { PORTAL_MORE_NAV } from '@/components/portal/portalNav';

const HINTS: Record<string, string> = {
  '/portal/treatment-courses': 'Dine behandlingsforløb',
  '/portal/documents': 'Filer delt af klinikken',
  '/portal/lab-results': 'Laboratoriesvar delt af klinikken',
  '/portal/punch-cards': 'Saldo, køb og historik',
  '/portal/consents': 'Samtykker og vilkår, der venter på dit svar',
  '/portal/profile': 'Navn og kontaktoplysninger',
  '/portal/clinics': 'Skift aktiv klinik',
  '/portal/data-export': 'Bestil en kopi af dine data',
};

export function PortalMore() {
  return (
    <>
      <PortalPageHead title="Mere" subtitle="Forløb, dokumenter, klippekort og dine data." />
      <section className="card">
        {PORTAL_MORE_NAV.map((item) => (
          <Link key={item.href} to={item.href} className="row">
            <span className="ic-tile">
              <PortalIcon name={item.icon === 'more' ? 'folder' : item.icon} />
            </span>
            <div className="grow">
              <div className="t">{item.label}</div>
              <div className="s">{HINTS[item.href] ?? ''}</div>
            </div>
            <PortalIcon name="chevronRight" size="sm" />
          </Link>
        ))}
      </section>
    </>
  );
}
